export class GroupLight {
    id: number;
    name: string;
}

export class Group extends GroupLight {
    description: string;
    publicData: boolean;
    parentId: number;
    nbStations: number;
    nbAP: number;
    nbBikes: number;
    nbUsers: number;
    freeFloatingEnabled: boolean;
    themeName?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/group.ts